import { REQUEST_CAPTIONS_SUCCESS, REQUEST_CAPTIONS_FAILURE, ADD_CAPTIONS_SUCCESS, UPDATE_CAPTIONS_SUCCESS, DELETE_CAPTIONS_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = {
  ids: [],
  errors: null
};

export default function captions(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_CAPTIONS_SUCCESS:
      return { ...state, ids: action.payload.data.map(data => data.id), errors: null };
    case REQUEST_CAPTIONS_FAILURE:
      return { ...state, ids: [], errors: action.payload.response && action.payload.response.data.errors };
    case ADD_CAPTIONS_SUCCESS:
      return { ...state, ids: [...state.ids, action.payload.data.id], erros: null };
    case UPDATE_CAPTIONS_SUCCESS:
      return { ...state, errors: null };
    case DELETE_CAPTIONS_SUCCESS:
      return { ...state, ids: state.ids.filter(id => id !== action.payload.data.id), errors: null };
    default:
      return state;
  }
}
